<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button style="margin:0px" type="primary" @click="handleAdd"
          >新增</el-button
        >
      </el-form-item>

      <!-- <el-form-item label="手机号: " style="margin-left:20px">
        <el-input
          v-model="phone"
          placeholder="请输入手机号"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="卡券状态: ">
        <el-select v-model="selectForm.state" placeholder="请选择" clearable>
          <div v-for="item in statusList" :key="item.id">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item> -->
    </el-form>
    <!-- 商品表格 -->
    <div style="height:75%">
      <el-table
        border
        :data="dataList"
        style="width: 100%;overflow-y: scroll;"
        height="calc(100vh - 220px)"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="卡券名称" align="center" width="130">
          <template slot-scope="scope">
            <el-tag size="medium">{{ scope.row.couponTitle }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="卡券金额" align="center" width="130">
          <template slot-scope="scope">
            <el-tag size="medium">{{ scope.row.price }}元</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="卡券描述" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.msg }}</span>
          </template>
        </el-table-column>
        <el-table-column label="核销状态" width="150" align="center">
          <template slot-scope="scope">
            <span style="color:red">{{
              scope.row.cardStatus == 1
                ? "未核销"
                : scope.row.cardStatus == 2
                ? "已核销"
                : "已失效"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="领取人手机号" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.userPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="核销时间" width="180" align="center">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.writeOffTime !== scope.row.createTime"
              type="danger"
              effect="dark"
              size="mini"
            >
              {{ scope.row.writeOffTime }}
            </el-tag>
            <div v-else>
              ——
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteBtn(scope.row)"
              :disabled="isRole"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增优惠券 -->
    <el-dialog
      title="新增优惠券"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="卡券状态: " :label-width="formLabelWidth">
          <el-select v-model="form.cardStatus" placeholder="请选择" clearable>
            <div v-for="item in statusList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="领取人手机号" :label-width="formLabelWidth">
          <el-input v-model="form.userPhone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="卡券名称" :label-width="formLabelWidth">
          <el-input v-model="form.couponTitle" auto-complete="off" placeholder="输入例如:新年狂欢优惠券,10元优惠券..."></el-input>
        </el-form-item>
        <el-form-item label="金额" :label-width="formLabelWidth">
          <el-input v-model="form.price" auto-complete="off" placeholder="输入数字:此处为优惠券实际能抵扣的金额"></el-input>
        </el-form-item>
        <el-form-item label="卡券描述" :label-width="formLabelWidth">
          <el-input v-model="form.msg" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改优惠券状态 -->
    <el-dialog
      title="修改优惠券状态"
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="卡券状态: ">
          <el-select v-model="form.cardStatus" placeholder="请选择" clearable>
            <div v-for="item in statusList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="updataLogisticsNumberBtn"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  add,
  selectList,
  deleteConpon,
  updateStatus,
} from "@/services/marketing/coupon";
import XLSX from "xlsx";
export default {
  data() {
    return {
      formLabelWidth: "120px",
      selectForm: {},
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      form: {
        logisticsNumber: "",
      },
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      isRole: false,
      statusList: [
        { id: 1, name: "未核销" },
        { id: 2, name: "已核销" },
      ],
    };
  },
  created() {
    this.select();
  },
  methods: {
    select() {
      // 查询订单数据
      selectList({ phone: this.phone, orderNumber: this.orderNumber }).then(
        (resp) => {
  
          this.dataList = resp.data;
          this.loading = false;
        }
      );
    },

    selectBtn() {
      this.select();
    },

    /* 新增优惠券 */
    handleAdd() {
      // 
      this.form = {};
      this.dialogFormVisible = true;
    },
    /* 确定新增 */
    saveAdd() {
      console.log(this.form);
      if (
        !this.form.cardStatus ||
        !this.form.couponTitle ||
        !this.form.msg ||
        !this.form.price ||
        !this.form.userPhone
      ) {
        this.$message.error("选项不能为空");
        return;
      }
      add(this.form).then((res) => {
 
        this.dialogFormVisible = false;
        this.$message.success("新增成功");
        this.select();
      });
    },

    /* 修改优惠券状态 */
    handleUpdate(row) {
      
      this.dialogFormVisible2 = true;
      this.form = JSON.parse(JSON.stringify(row));
    },

    // 确认修改
    updataLogisticsNumberBtn() {
      // if (this.form.logisticsNumber == "") {
      //   this.$message.error("请填写物流单号");
      //   return;
      // }
      updateStatus({
        id: this.form.id,
        cardStatus: this.form.cardStatus,
      }).then((res) => {
 
        this.dialogFormVisible2 = false;
        this.$message.success("操作成功");
        this.select();
      });
    },
    deleteBtn(row) {
      this.$confirm("此操作将永久删除该优惠券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteConpon({
            id:row.id
          }).then((resp) => {
    
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "id",
          "订单号",
          "姓名",
          "手机号",
          "收货地址",
          "留言",
          "订单总价",
          "物流单号",
          "卡券状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "商品明细",
          "下单时间",
        ];
        const filterVal = [
          "id",
          "orderNumber",
          "name",
          "phone",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "status",
          "productList",
          "createTime",
        ];
        const dataList = JSON.parse(JSON.stringify(this.dataList));
        const list = dataList.map((item) => {
          const product = item.productList.map((item2) => {
            return `${item2.productName}(${item2.price}元)X${item2.num}`;
          });
          item.productList = JSON.parse(JSON.stringify(product));
          return {
            ...item,
            productList: item.productList.join(","),
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "订单列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },

    // 导入数据
    importExcel(file) {
      // let file = file.files[0] // 使用传统的input方法需要加上这一步
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlm", "xls"].some((item) => item === types);
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then((tabJson) => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          let dateXlx = tabJson[0].sheet; //导入的数据数组
          console.log("------导入的数据为", this.xlsxJson, dateXlx);
          // 判断每一项的姓名 生日 客户类型是否为空 为空则不导入
          // var result = dateXlx.every((item) => {
          //   console.log(item);
          //   return item.name && item.type;
          // });
          // if (!result) {
          //   this.$message.error("姓名，客户类型不能为空！");
          //   return;
          // }
          // 一项项导入数据
          dateXlx.forEach((item) => {
            console.log("item");
            updateStatus(item.id, item["物流单号"]).then((res) => {
       
              this.select();
            });
          });
        }
      });
    },
    file2Xce(file) {
      // return new Promise(function (resolve, reject) {
      return new Promise(function(resolve) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary",
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName]),
            });
          });
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file) // 传统input方法
      });
    },
  },
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.addressDetail:hover {
  cursor: pointer;
}
</style>
